import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { dbPost } from '../../apis/commonApi';
import { GlobalContext, ModalContext } from '../../components/contexts';
import { useNavigate, useLocation } from 'react-router-dom';
import img1 from '../../assets/img/contents/1.png';
import img2 from '../../assets/img/contents/2.png';
import img3 from '../../assets/img/contents/3.png';
import img4 from '../../assets/img/contents/4.png';
import img5 from '../../assets/img/contents/5.png';
import img6 from '../../assets/img/contents/6.png';
import img7 from '../../assets/img/contents/7.png';
import img8 from '../../assets/img/contents/8.png';
import img9 from '../../assets/img/contents/9.png';
import img10 from '../../assets/img/contents/10.png';
import img11 from '../../assets/img/contents/11.png';
import ButtonPrint from '../../components/buttonComponents/ButtonPrint';

const CheckList = () => {
  useEffect(() => {
    document.title = '유해요인조사관리-부담작업 체크리스트';
  }, []);

  const contentRef = useRef(null);

  const location = useLocation();
  const { store, updateStore } = useContext(GlobalContext);
  const { modalService } = useContext(ModalContext);
  const navigate = useNavigate();
  const [workList, setWorkList] = useState([]);
  const [postData, setPostData] = useState([]);
  const [currentDate, setCurrentDate] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [radioSe, setRadioSe] = useState('A');
  const [state, setState] = useState(location.state);

  const [formData, setFormData] = useState({
    userType: '',
    userNm: '',
    flag: location.flag || '',
    taskId: location.taskId || '',
    entSn: location.entSn || '',
    aiaAplyId: location.aiaAplyId || '',
  });

  const [pageValue, setPageValue] = useState({
    taskNm: '',
    taskExpln: '',
    userNm: store.userNm,
  });

  useEffect(() => {
    if (location.state) {
      setState(location.state);
      setFormData(state);
      // sessionStorage.setItem(
      //   'surveyCheckState',
      //   JSON.stringify(location.state)
      // );
    }
  }, [location.state]);

  useEffect(() => {
    if (formData.flag == 'new' && workList.length === 0) {
      getTaskInfoTaskId();
      getWorkInfoTaskId();
    } else if (formData.flag == 'ex' && workList.length === 0) {
      getTaskInfoAia();
      getWorkInfoAia();
    }
  }, [formData]);

  const getTaskInfoTaskId = () => {
    const url = '/aia/checkList/getTaskInfoTaskId.do';
    const param = {
      taskId: formData.taskId,
    };

    dbPost(url, param)
      .then(response => {
        const taskInfo = response;
        setPageValue(taskInfo);
      })
      .catch(error => {});
  };

  // 작업 리스트로 받아옴
  const getWorkInfoTaskId = () => {
    const url = '/aia/checkList/getWorkInfoTaskId.do';
    const param = {
      taskId: formData.taskId,
    };
    dbPost(url, param)
      .then(response => {
        const workList = Array.isArray(response) ? response : [];
        for (let i = 0; i < workList.length; i++) {
          workList[i].entSn = state.entSn;
          workList[i].userNm = store.userNm;
          workList[i].taskId = state.taskId;
        }
        if (workList.length === 0) {
          modalService.errorAlert(
            '등록된 작업이 없습니다. <br /> 작업정보관리에서 작업을 추가해 주시길 바랍니다',
            () => {
              navigate('/ai/task');
            }
          );
        }
        setWorkList(workList);
      })
      .catch(error => {});
  };

  const getTaskInfoAia = () => {
    const url = '/aia/checkList/getTaskInfoAia.do';
    const param = {
      aiaAplyId: formData.aiaAplyId,
    };
    dbPost(url, param)
      .then(response => {
        const taskList = response;
        setPageValue(taskList);
      })
      .catch(error => {});
  };

  const getWorkInfoAia = () => {
    const url = '/aia/checkList/getWorkInfoAia.do';
    const param = {
      aiaAplyId: formData.aiaAplyId,
    };
    dbPost(url, param)
      .then(response => {
        const workList = Array.isArray(response) ? response : [];
        for (let i = 0; i < workList.length; i++) {
          workList[i].entSn = state.entSn;
          workList[i].userNm = store.userNm;
          workList[i].aiaAplyId = formData.aiaAplyId;
        }
        if (workList.length === 0) {
          modalService.errorAlert('등록된 작업이 없습니다.', () => {
            navigate(-1);
          });
        }
        setWorkList(workList);
      })
      .catch(error => {});
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setCurrentDate(formattedDate);
  }, []);

  const handleCheckboxChange = (value, strainWorkKey) => {
    const temp = [...workList];
    for (let index = 0; index < temp.length; index++) {
      const item = temp[index];

      if (item.workId === value) {
        item[strainWorkKey] = item[strainWorkKey] === 'Y' ? 'N' : 'Y';
      }
    }

    setWorkList(temp);
  };

  const handleCheckboxChnge = e => {
    setIsDisabled(!e.target.checked);
  };

  const beforeSave = () => {
    let selectedTaskCnt = 0;
    const updatedPostData = [];
    setPostData([]);
    let j = 0;
    for (let i = 0; i < workList.length; i++) {
      j++;
      const workItem = { ...workList[i] };
      for (const key in workItem) {
        if (workItem[key] == null) {
          workItem[key] = 'N';
        }
        workItem['se'] = radioSe;
      }
      if (workItem['strgYn'] === 'Y') {
        selectedTaskCnt++;
      }
      updatedPostData.push(workItem);
    }

    if (selectedTaskCnt === 0) {
      modalService.errorAlert('AI분석을 할 작업이 없습니다.');
      return;
    } else {
      setPostData(updatedPostData);
    }
  };

  useEffect(() => {
    if (formData.flag == 'new' && postData.length > 0) {
      saveWorkList();
    } else if (formData.flag == 'ex' && postData.length > 0) {
      saveWorkListAia();
    }
  }, [postData]);

  const saveWorkList = () => {
    const url = '/aia/checkList/saveWorkList.do';
    const param = postData;
    dbPost(url, param)
      .then(response => {
        setFormData(prevFormData => ({
          ...prevFormData,
          aiaAplyId: response,
          flag: 'ex',
        }));
        modalService.successAlert('저장이 완료되었습니다.', () => {
          navigate('/ai/reqVideo', {
            state: {
              entSn: formData.entSn,
              aiaAplyId: response,
            },
          });
        });
      })
      .catch(error => {});
  };

  const saveWorkListAia = () => {
    const url = '/aia/checkList/saveWorkListAia.do';
    dbPost(url, postData)
      .then(response => {
        modalService.successAlert('저장이 완료되었습니다.', () => {
          navigate('/ai/reqVideo', {
            state: {
              entSn: formData.entSn,
              aiaAplyId: formData.aiaAplyId,
            },
          });
        });
      })
      .catch(error => {});
  };

  const handleRadioChange = value => {
    setRadioSe(value);
  };

  const workArea = useMemo(() => {
    return (
      <>
        {workList.map(work => {
          return (
            <tr key={work.workId}>
              <th
                className="bg2"
                style={{
                  position: 'sticky',
                  left: 0,
                  zIndex: 200,
                  border: '2px solid #ddd',
                }}
              >
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'strgYn'}
                    id={work.workId + 'strgYn'}
                    checked={work.strgYn === 'Y'}
                    onChange={() => handleCheckboxChange(work.workId, 'strgYn')}
                  />
                  <label htmlFor={work.workId + 'strgYn'}>
                    <span>{work.workNm}</span>
                  </label>
                </div>
              </th>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork01'}
                    id={work.workId + 'loadWork01'}
                    checked={work.loadWork01 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork01')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork01'}>
                    <span className="sr-only">작업 1</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork02'}
                    id={work.workId + 'loadWork02'}
                    checked={work.loadWork02 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork02')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork02'}>
                    <span className="sr-only">작업 2</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork03'}
                    id={work.workId + 'loadWork03'}
                    checked={work.loadWork03 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork03')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork03'}>
                    <span className="sr-only">작업 3</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork04'}
                    id={work.workId + 'loadWork04'}
                    checked={work.loadWork04 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork04')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork04'}>
                    <span className="sr-only">작업 4</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork05'}
                    id={work.workId + 'loadWork05'}
                    checked={work.loadWork05 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork05')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork05'}>
                    <span className="sr-only">작업 5</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork06'}
                    id={work.workId + 'loadWork06'}
                    checked={work.loadWork06 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork06')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork06'}>
                    <span className="sr-only">작업 6</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork07'}
                    id={work.workId + 'loadWork07'}
                    checked={work.loadWork07 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork07')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork07'}>
                    <span className="sr-only">작업 7</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork08'}
                    id={work.workId + 'loadWork08'}
                    checked={work.loadWork08 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork08')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork08'}>
                    <span className="sr-only">작업 8</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork09'}
                    id={work.workId + 'loadWork09'}
                    checked={work.loadWork09 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork09')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork09'}>
                    <span className="sr-only">작업 9</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork10'}
                    id={work.workId + 'loadWork10'}
                    checked={work.loadWork10 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork10')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork10'}>
                    <span className="sr-only">작업 10</span>
                  </label>
                </div>
              </td>
              <td className="bg2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name={work.workId + 'loadWork11'}
                    id={work.workId + 'loadWork11'}
                    checked={work.loadWork11 === 'Y'}
                    onChange={() =>
                      handleCheckboxChange(work.workId, 'loadWork11')
                    }
                  />
                  <label htmlFor={work.workId + 'loadWork11'}>
                    <span className="sr-only">작업 11</span>
                  </label>
                </div>
              </td>
            </tr>
          );
        })}
      </>
    );
  }, [workList]);

  return (
    <>
      <style>
        {`
      img {
        margin: 0 auto;
      }
    `}
      </style>
      <div ref={contentRef}>
        <div className="page-title-wrap" data-type="responsive">
          <h2 className="h-tit">유해요인조사관리-부담작업 체크리스트</h2>
        </div>
        <ul className="guide-txt">
          <li>
            기업 내 공정을 선택하고 해당 공정의 단위작업에 부담작업 해당여부를
            체크해 주세요.
          </li>
          <li>
            판단이 어려운 경우 AI영상분석을 통해 근골격계 부담작업 해당여부
            판단에 도움을 받을 수 있습니다.
          </li>
          <li>
            AI영상 분석 도움이 필요한 작업은 작업명 앞에 체크박스를
            체크해주세요.
          </li>
        </ul>
        <div className="tbl-wrap">
          <p className="tbl-msg">
            <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
          </p>
          <table className="tbl data row">
            <colgroup>
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  공정<em className="star-require">*</em>
                </th>
                <td>
                  <div className="input-group">
                    <p>{pageValue?.taskNm || ''}</p>
                  </div>
                </td>
                <th scope="row">조사일자</th>
                <td>
                  <p>{currentDate}</p>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  공정 상세내용<em className="star-require">*</em>
                </th>
                <td>
                  <p>{pageValue?.taskExpln || ''}</p>
                </td>
                <th scope="row">조사자</th>
                <td>
                  <p>{store.userNm}</p>
                </td>{' '}
              </tr>
              <tr>
                <th scope="row">
                  조사구분<em className="star-require">*</em>
                </th>
                <td colSpan={3}>
                  <div
                    className="form-check"
                    style={{ display: 'inline-block', marginRight: '10px' }}
                  >
                    <input
                      type="radio"
                      id="radio_A"
                      name="radioSe"
                      value="A"
                      checked={radioSe === 'A'}
                      onChange={e => handleRadioChange(e.target.value)}
                    />
                    <label htmlFor="radio_A">정기</label>
                  </div>
                  <div
                    className="form-check"
                    style={{ display: 'inline-block', marginRight: '10px' }}
                  >
                    <input
                      type="radio"
                      id="radio_O"
                      name="radioSe"
                      value="O"
                      checked={radioSe === 'O'}
                      onChange={e => handleRadioChange(e.target.value)}
                    />
                    <label htmlFor="radio_O">수시</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ol className="step-wrap">
          <li className="active">
            <span>
              <em className="sr-only">현재단계</em>
              <span className="step-tit">부담작업 체크리스트 작성</span>
            </span>
          </li>
          <li>
            <span>
              <span className="step-tit">영상 업로드</span>
            </span>
          </li>
          <li>
            <span>
              <span className="step-tit">AI영상분석신청</span>
            </span>
          </li>
          <li>
            <span>
              <em className="sr-only">현재단계</em>
              <span className="step-tit">AI영상분석완료</span>
            </span>
          </li>
          <li>
            <span>
              <span className="step-tit">유해요인 기본조사표 작성</span>
            </span>
          </li>
        </ol>
        <div className="tbl-wrap">
          <h3 className="block-tit">근골격계 부담작업 체크리스트</h3>
          <div className="tbl-scroll-box">
            <table className="tbl row data divide">
              <colgroup>
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th
                    className="bg1"
                    style={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 200,

                      border: '2px solid #ddd',
                    }}
                  >
                    구분
                  </th>
                  <td>
                    <img src={img1} alt="근골격계 부담작업1" />
                  </td>
                  <td>
                    <img src={img2} alt="근골격계 부담작업2" />
                  </td>
                  <td>
                    <img src={img3} alt="근골격계 부담작업3" />
                  </td>
                  <td>
                    <img src={img4} alt="근골격계 부담작업4" />
                  </td>
                  <td>
                    <img src={img5} alt="근골격계 부담작업5" />
                  </td>
                  <td>
                    <img src={img6} alt="근골격계 부담작업6" />
                  </td>
                  <td>
                    <img src={img7} alt="근골격계 부담작업7" />
                  </td>
                  <td>
                    <img src={img8} alt="근골격계 부담작업8" />
                  </td>
                  <td>
                    <img src={img9} alt="근골격계 부담작업9" />
                  </td>
                  <td>
                    <img src={img10} alt="근골격계 부담작업10" />
                  </td>
                  <td>
                    <img src={img11} alt="근골격계 부담작업11" />
                  </td>
                </tr>
                <tr>
                  <th
                    style={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 200,
                      border: '2px solid #ddd',
                    }}
                  >
                    하루 총 노출시간
                  </th>
                  <td>4시간 이상</td>
                  <td>2시간 이상</td>
                  <td>2시간 이상</td>
                  <td>2시간 이상</td>
                  <td>2시간 이상</td>
                  <td>2시간 이상</td>
                  <td>2시간 이상</td>
                  <td colSpan="2" className="bg1">
                    -
                  </td>
                  <td>2시간 이상</td>
                  <td>2시간 이상</td>
                </tr>
                <tr>
                  <th
                    style={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 200,
                      border: '2px solid #ddd',
                    }}
                  >
                    노출빈도
                  </th>
                  <td colSpan="7">4시간 이상</td>
                  <td>하루에 10회 이상</td>
                  <td>하루에 25회 이상</td>
                  <td>분당 2회 이상</td>
                  <td>시간당 10회 이상</td>
                </tr>
                <tr>
                  <th
                    style={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 200,
                      border: '2px solid #ddd',
                    }}
                  >
                    신체부위
                  </th>
                  <td>손, 손가락</td>
                  <td>목, 어깨, 손목, 손, 팔꿈치</td>
                  <td>어깨, 팔</td>
                  <td>목, 허리</td>
                  <td>다리, 무릎</td>
                  <td>손가락</td>
                  <td>손</td>
                  <td>허리</td>
                  <td>손, 무릎</td>
                  <td>허리</td>
                  <td>손, 무릎, 팔꿈치</td>
                </tr>
                <tr>
                  <th
                    style={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 200,
                      border: '2px solid #ddd',
                    }}
                  >
                    작업자세 및 내용
                  </th>
                  <td>
                    집중적인 자료 입력 작업
                    <br />
                    (마우스, 키보드 사용)
                  </td>
                  <td>같은 동작 반복작업</td>
                  <td>
                    머리 위의 손,
                    <br />
                    팔꿈치가 몸통으로부터 들림,
                    <br />
                    팔꿈치를 몸통 뒤쪽에 위치
                  </td>
                  <td>구부리거나 비틈</td>
                  <td>쪼그리고 앉거나 무릎을 굽힘</td>
                  <td>한 손가락 집기 작업</td>
                  <td>물건을 잡는 작업</td>
                  <td>물건을 드는 작업</td>
                  <td>
                    무릎 아래/어깨 위에서 들기,
                    <br />
                    팔을 뻗은 상태에서 물건을 드는 작업
                  </td>
                  <td>물건을 드는 작업</td>
                  <td>반복적인 충격</td>
                </tr>
                <tr>
                  <th
                    style={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 200,
                      border: '2px solid #ddd',
                    }}
                  >
                    무게
                  </th>
                  <td colSpan="5" className="bg1">
                    -
                  </td>
                  <td>
                    1kg 이상의 물건,
                    <br />
                    2kg 이상에 상응하는 힘
                  </td>
                  <td>
                    4.5kg 이상 물건,
                    <br />
                    동일한 무게의 힘
                  </td>
                  <td>25kg 이상</td>
                  <td>10kg 이상</td>
                  <td>4.5kg 이상</td>
                  <td className="bg1">-</td>
                </tr>
                {workArea}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="page-btn-wrap both">
        <div className="form-check">
          <input type="checkbox" id="chk_01" onChange={handleCheckboxChnge} />
          <label htmlFor="chk_01">해당 내용을 단위작업정보에 저장합니다.</label>
        </div>
        <div className="btn-group">
          <ButtonPrint
            buttonName="인쇄"
            printRef={contentRef}
            landScape={true}
            disabled={isDisabled}
          />
          <button
            type="button"
            disabled={isDisabled}
            className="btn xlg primary"
            onClick={beforeSave}
          >
            저장
          </button>
        </div>
      </div>
    </>
  );
};

export default CheckList;
